import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

// types
import { StoreData, StoreUpdateData } from '../types/storeTypes'

// helpers
import { delayHttpRequest } from '../helpers/globalHelper'

// services
import { storeService } from '../services/storeService'

// stores
import { useHomeStore } from './home'

type Store = {
  storeData: StoreData
  loading: boolean
  error: string | null
  clearData: () => void
  fetchData: (id: number) => void
  updateData: (id: number, feed: StoreUpdateData) => void
}

const useStoreStore = create(
  devtools<Store>((set) => ({
    storeData: null,
    loading: false,
    error: null,
    clearData: () => set({ storeData: null, loading: false, error: null }),
    fetchData: async (id) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _storeData = await storeService.fetchData(id)
        set((state) => ({ ...state, storeData: _storeData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    updateData: async (id, feed) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _storeData = await storeService.updateData(id, feed)
        set((state) => ({ ...state, storeData: _storeData }))

        // fetch home data
        useHomeStore.getState().fetchData(id)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    }
  }))
)

export { useStoreStore }
